import { Clock } from 'lucide-react-native';
import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';

export type SocialPendingChipProps = {
  /** The server's word for the wait ("In review"). */
  label: string;
  testID?: string;
};

/**
 * A step waiting on someone else ("Reviewing application", "Preparing to
 * ship", "In review"): a quiet outlined row with a clock (Figma "Get paid"
 * after the video is in). Nothing to tap, so it never looks like a button.
 */
export function SocialPendingChip({ label, testID }: SocialPendingChipProps) {
  return (
    <View style={styles.chip} accessible accessibilityLabel={label} testID={testID}>
      <Clock size={18} color={colors.textMuted} strokeWidth={2} />
      <Text variant="bodyBold" color="textMuted">
        {label}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.sm,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.base,
    borderRadius: radii.lg,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
  },
});
